import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProfilePictureType {
  avatarName?: string;
}

const initialState: ProfilePictureType = {
  avatarName: '',
};

const profileSlice = createSlice({
  name: 'profileUpdate',
  initialState,
  reducers: {
    selectedProfileAction: (state, { payload }: PayloadAction<string>) => {
      return {
        ...state,
        avatarName: payload,
      };
    },
  },
});

const { reducer, actions } = profileSlice;

export const { selectedProfileAction } = actions;

export const profileApiReducer = reducer;
